export function convertObjectIntoQueryString(obj: Record<string, string>): string {
  return Object.keys(obj).map((key: string) => {
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(obj[key]);
    return `${encodedKey}=${encodedValue}`;
  }).join('&');
}
